export class Task {
  taskId: number;
  jsonChildTask: string;
  msgId: number;
  name: string;
  miniDoc: string;
  taskDocuments: any[];
  dateDue: any;
  assignedTo: any;
  createdBy: any;
  requestedBy: any;
  ownedBy: any;
  intervalTaskRepeat: any;
  dateStart: any;
  phase: any;
  ischild: boolean;
  parent: Task;
  children: Task[];
  status: any;
  isTemplate: boolean;

}
